<template>
  <div class="quiz-info-section">
    <div class="quiz-info-head">
      <div class="quiz-order">
        {{ `${order} / ${totalQuiz}` }}
      </div>
      <div
        class="quiz-marker"
        @click="injectSurveyScript"
      >
        <i class="far fa-bookmark" />
      </div>
    </div>
    <div class="quiz-info-wrapper">
      <div v-if="slide.title" class="quiz-title">
        {{ slide.title }}
      </div>
      <div v-if="slide.image" class="quiz-image">
        <QuizImage
          v-zoom="{
            imgSource: slide.image
          }"
          :src="slide.image && slide.image.thumbnail"
        />
      </div>
    </div>
    <div class="quiz-desc" v-if="slide.titleDesc">
      {{ slide.titleDesc }}
    </div>
  </div>
</template>

<script>
import Config from '@/config'
import QuizImage from './QuizImage.vue'

export default {
  components: {
    QuizImage,
  },
  props: {
    slide: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    injectSurveyScript() {
      const myQuizAnswersSurveyEl = document.querySelector('#my-quiz-answers-survey')

      if (myQuizAnswersSurveyEl) return

      const surveyId = Config.env !== 'production'
        ? 'bc50965f-5e7b-45cb-8477-c2b85e2a1c61'
        : 'a41fb34d-817f-4141-a7dc-d5bdac99eb2d'
      const surveyScript = document.createElement('script')
      surveyScript.type = 'text/javascript'
      surveyScript.setAttribute('id', 'my-quiz-answers-survey')
      surveyScript.innerHTML = `
        (window.CE_API || (window.CE_API=[])).push(function(){
            CE2.showSurvey("${surveyId}");
        });
      `
      document.head.appendChild(surveyScript)
    },
  },
}
</script>

<style lang="scss" scoped>
.quiz-info-section {
  margin-bottom: 12px;
}

.quiz-info-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.quiz-marker {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid var(--secondary-20, #D3D7E1);
  color: #313131;
  background: #FFF;
  transition: 0.2s all ease;

  @media screen and (min-width: 1280px) {
    &:hover, &:focus {
      color: #FFF;
      background: var(--primary-85, #4F9BF3);
    }
  }
}

.quiz-order {
  align-self: flex-start;
  border-radius: 14px;
  font-size: 14px;
  background: var(--secondary-15, #EFF1F7);
  padding: 4px 8px;
  margin-bottom: 8px;
}

.quiz-title {
  margin-bottom: 12px;
  color: var(--base-90, #313131);
  font-size: 16px;
  font-weight: bold;
}

.quiz-info-wrapper {
  display: grid;
  gap:12px;
  grid-template-columns: 1fr auto;

  .quiz-image {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
